var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Estado de Guia","company":_vm.comdes,"addMethod":"itemsEstadoGuia","closeBaseWindow":"addEstadoGuia","titleAddMethod":"Agregar Estado de Guia","itemStoreName":"itemsEstadoGuia","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Estado de Guia',
    edicion: 'Editar Estado de Guia',
    url: `/transjuma/EstadoGuia/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }